<template>
  <section v-bind="sectionProps">
    <v-container v-bind="containerProps">
      <v-row v-bind="contentRowProps">
        <v-col v-bind="contentColumnProps">
          <div
            class="section-html"
            v-if="section.content.html"
            v-inline-editable.html="section.content.html"
          ></div>
        </v-col>
      </v-row>
    </v-container>

    <parallax-background-image
      v-if="section.design['background-image']"
      :section="section"
      v-bind="backgroundImageProps"
    ></parallax-background-image>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
import ParallaxBackgroundImage from '@/components/sections/partials/elements/ParallaxBackgroundImage'

export default {
  name: 'ContentDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    }
  },
  components: {
    ParallaxBackgroundImage
  },
  computed: {
    sectionProps() {
      let additionalStyle = {}

      if (this.parseBoolean(this.section.design['custom-padding'])) {
        additionalStyle.paddingTop = this.section.design['padding-top']
        additionalStyle.paddingBottom = this.section.design['padding-bottom']
      }

      return {
        style: {
          backgroundColor: this.section.design['background-color'],
          ...additionalStyle
        }
      }
    },
    backgroundImageProps() {
      return {
        style: {
          height: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    containerProps() {
      return {
        'fill-height': true,
        fluid: this.parseBoolean(
          this.section.layout['content-container-fluid']
        ),
        style: {
          position: 'relative',
          zIndex: 1
        }
      }
    },
    contentRowProps() {
      return {
        'no-gutters': true,
        class: [
          `justify-${this.section.layout['content-horizontal-alignment']}`,
          `text-${this.section.layout['content-justify']}`
        ]
      }
    },
    contentColumnProps() {
      let additionalProps = {}

      if (!this.parseBoolean(this.section.layout['content-container-fluid'])) {
        additionalProps = {
          ...this.calculateColumnContainerSize(
            this.section.layout['content-container-size']
          )
        }
      }

      return {
        ...additionalProps,
        style: {
          position: 'relative'
        }
      }
    }
  }
}
</script>
